export default __webpack_public_path__ + "static/media/idea.718cc3b4.svg";